import { FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import DependentQuestions from "@/containers/survey/components/DependentQuestions";
import { useTranslation } from "react-i18next";
import Field from "@/components/Field";
import VariantsList from "./VariantsList";
import Fieldset from "@/components/Fieldset";
import { isRequired } from "@/lib/form";
import { cfg } from "@/schemas/question/cfg";

interface QuestionSelectProps {
  index: number;
}

const QuestionSelect = ({ index }: QuestionSelectProps) => {
  const { t } = useTranslation();

  const translationKeys = {
    variant: "surveyEditor.selectType.variant",
    addVariant: "surveyEditor.selectType.addVariant",
    noVariantsFound: "surveyEditor.selectType.noVariantsFound",
  };

  return (
    <Fieldset>
      <Field
        name={`questions.${index}.cfg.minChecked`}
        label={t("surveyEditor.selectType.minChecked")}
        required={isRequired(cfg.shape.minChecked)}
        render={({ field }) => (
          <Input type="number" className="w-24" {...field} />
        )}
      />
      <Field
        name={`questions.${index}.cfg.maxChecked`}
        label={t("surveyEditor.selectType.maxChecked")}
        required={isRequired(cfg.shape.maxChecked)}
        render={({ field }) => (
          <Input type="number" className="w-24" {...field} />
        )}
      />
      <FormLabel>{t("surveyEditor.selectType.variants")}</FormLabel>
      <VariantsList
        name={`questions.${index}.cfg.variants`}
        translationKeys={translationKeys}
      />
      <DependentQuestions index={index} />
    </Fieldset>
  );
};

export default QuestionSelect;
